import { useQuery, useMutation } from '@tanstack/react-query'
import { fetchDashboardUser } from '../services/dashboard-user.service'
import type { DashboardUser } from '../types/dashboard-user'

export const useDashboardUser = (employeeId: string) => {
  return useQuery({
    queryKey: ['dashboard-user', employeeId],
    queryFn: () => fetchDashboardUser(employeeId),
    enabled: !!employeeId,
    staleTime: 10 * 60 * 10, // 10 minutes
    gcTime: 10 * 60 * 60, // 1 hours (formerly cacheTime)
  })
}

/** Imperative fetch for use in callbacks (e.g. login success). Call at hook top level, then use the returned function inside callbacks. */
export const useFetchDashboardUser = () => {
  const mutation = useMutation<DashboardUser, Error, string>({
    mutationFn: (employeeId: string) => fetchDashboardUser(employeeId),
  })
  return {
    fetchDashboardUser: mutation.mutateAsync,
    isLoading: mutation.isPending,
    error: mutation.error,
  }
}
